(function () {
  const overlay = document.getElementById('JadeFallingMotifs');
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!overlay || overlay.dataset.initialized === 'true') {
    return;
  }

  if (reduceMotionQuery.matches) {
    overlay.style.display = 'none';
    return;
  }

  overlay.dataset.initialized = 'true';
  overlay.style.removeProperty('display');

  const isMobileQuery = window.matchMedia('(max-width: 767px)');
  const motifDefinitions = [
    {
      type: 'petal',
      weight: 50,
      size: [22, 34],
      alpha: [0.26, 0.48],
      drift: [-28, 28],
      sway: [8, 16],
      rotate: [70, 160],
      svg:
        '<svg viewBox="0 0 36 36" fill="none" aria-hidden="true"><path d="M18 3C23.7 7.7 27.1 13.6 26 19.7C24.8 26.2 20.6 31.2 16.9 33C13 29.8 9.8 25.2 9.4 19.2C9 13.5 12.1 8.1 18 3Z" fill="currentColor"/><path d="M18 8.5C20.7 11.5 22.4 15 22 18.9C21.5 23.8 18.9 27.1 16.7 28.7" stroke="rgba(255,255,255,0.38)" stroke-width="1.1" stroke-linecap="round"/></svg>'
    },
    {
      type: 'heart',
      weight: 30,
      size: [16, 24],
      alpha: [0.24, 0.44],
      drift: [-22, 22],
      sway: [6, 14],
      rotate: [50, 120],
      svg:
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21C11.4 20.5 10.6 20 9.7 19.4C5.5 16.5 2.2 13.3 2.2 8.9C2.2 5.8 4.6 3.8 7.4 3.8C9.3 3.8 10.9 4.7 12 6.2C13.1 4.7 14.7 3.8 16.6 3.8C19.4 3.8 21.8 5.8 21.8 8.9C21.8 13.3 18.5 16.5 14.3 19.4C13.4 20 12.6 20.5 12 21Z" fill="currentColor"/></svg>'
    },
    {
      type: 'knot',
      weight: 20,
      size: [18, 28],
      alpha: [0.18, 0.34],
      drift: [-20, 20],
      sway: [10, 18],
      rotate: [90, 180],
      svg:
        '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M16 5.5C10.2 5.5 5.5 10.2 5.5 16C5.5 21.8 10.2 26.5 16 26.5C21.8 26.5 26.5 21.8 26.5 16C26.5 10.2 21.8 5.5 16 5.5Z" stroke="currentColor" stroke-width="1.2"/><path d="M16 9V23M9 16H23M11.2 11.2L20.8 20.8M20.8 11.2L11.2 20.8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>'
    }
  ];

  let topActiveCount = 0;
  let bottomActiveCount = 0;
  let spawnTimer = 0;
  let strengthFrame = 0;
  let lastScrollY = window.scrollY;
  let scrollDirection = 'idle';
  let lastDownPulseAt = -Infinity;
  let lastBottomSpawnAt = -Infinity;
  let nextBottomSustainDelay = 0;
  let destroyed = false;

  const transientTimers = new Set();

  function bindMediaQueryChange(query, handler) {
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', handler);
      return;
    }

    if (typeof query.addListener === 'function') {
      query.addListener(handler);
    }
  }

  function unbindMediaQueryChange(query, handler) {
    if (typeof query.removeEventListener === 'function') {
      query.removeEventListener('change', handler);
      return;
    }

    if (typeof query.removeListener === 'function') {
      query.removeListener(handler);
    }
  }

  function trackTimeout(callback, delay) {
    const timer = window.setTimeout(function () {
      transientTimers.delete(timer);
      callback();
    }, delay);

    transientTimers.add(timer);
    return timer;
  }

  function sample(range) {
    return range[0] + Math.random() * (range[1] - range[0]);
  }

  function chooseDefinition() {
    const total = motifDefinitions.reduce((sum, item) => sum + item.weight, 0);
    let cursor = Math.random() * total;

    for (const definition of motifDefinitions) {
      cursor -= definition.weight;
      if (cursor <= 0) {
        return definition;
      }
    }

    return motifDefinitions[0];
  }

  function pickSpawnX() {
    const band = Math.random();

    if (band < 0.4) {
      return 4 + Math.random() * 22;
    }

    if (band < 0.8) {
      return 74 + Math.random() * 22;
    }

    return 30 + Math.random() * 40;
  }

  function getRuntimeProfile() {
    if (isMobileQuery.matches) {
      return {
        top: {
          maxActive: 4,
          interval: [1900, 2900],
          duration: [17, 23],
          sizeScale: 0.88
        },
        bottom: {
          maxActive: 1,
          pulseCount: [1, 1],
          sustainInterval: [2200, 3200],
          duration: [6.4, 7.4],
          sizeScale: 0.84
        }
      };
    }

    return {
      top: {
        maxActive: 8,
        interval: [980, 1650],
        duration: [15, 20],
        sizeScale: 1.12
      },
      bottom: {
        maxActive: 3,
        pulseCount: [2, 3],
        sustainInterval: [1200, 1850],
        duration: [7.4, 9.2],
        sizeScale: 1.06
      }
    };
  }

  function computeStrength() {
    const viewportHeight = Math.max(window.innerHeight || 0, 1);
    const screens = window.scrollY / viewportHeight;

    if (screens <= 1) {
      return 1;
    }

    if (screens <= 2) {
      return 1 - (screens - 1) * 0.3;
    }

    if (screens <= 3) {
      return 0.7 - (screens - 2) * 0.44;
    }

    return 0.26;
  }

  function getNow() {
    if (window.performance && typeof window.performance.now === 'function') {
      return window.performance.now();
    }

    return Date.now();
  }

  function randomInt(range) {
    return Math.floor(range[0] + Math.random() * (range[1] - range[0] + 1));
  }

  function refreshBottomSustainDelay() {
    nextBottomSustainDelay = sample(getRuntimeProfile().bottom.sustainInterval);
  }

  function updateScrollDirection() {
    const currentY = window.scrollY;
    const delta = currentY - lastScrollY;

    if (Math.abs(delta) < 6) {
      return;
    }

    scrollDirection = delta > 0 ? 'down' : 'up';
    lastScrollY = currentY;
  }

  function canTriggerBottomPulse(now) {
    return scrollDirection === 'down' && now - lastDownPulseAt >= 1100;
  }

  function canSustainBottomBurst(now) {
    return scrollDirection === 'down' && now - lastBottomSpawnAt >= nextBottomSustainDelay;
  }

  function applyStrength() {
    strengthFrame = 0;
    overlay.style.setProperty('--jg-falling-strength', computeStrength().toFixed(3));
  }

  function requestStrengthSync() {
    if (strengthFrame || destroyed) {
      return;
    }

    strengthFrame = window.requestAnimationFrame(applyStrength);
  }

  function buildNode(channel) {
    const definition = chooseDefinition();
    const profile = getRuntimeProfile()[channel];
    const node = document.createElement('span');
    const inner = document.createElement('span');
    const driftScale = channel === 'bottom' ? 0.72 : 1;
    const swayScale = channel === 'bottom' ? 0.9 : 1;
    const rotationScale = channel === 'bottom' ? 0.78 : 1;
    const size = sample(definition.size) * profile.sizeScale;
    const drift = sample(definition.drift) * driftScale;
    const sway = sample(definition.sway) * swayScale * (Math.random() > 0.5 ? 1 : -1);
    const rotation = sample(definition.rotate) * rotationScale * (Math.random() > 0.5 ? 1 : -1);
    let duration = sample(profile.duration);
    const alphaBoost = channel === 'bottom' ? 0.06 : 0.04;
    const alpha = Math.min(sample(definition.alpha) + alphaBoost, 0.62);

    const isSmall = size < 22;
    if (isSmall && !isMobileQuery.matches) {
      node.classList.add('is-blur');
      duration *= 1.22;
    }

    node.className = `jg-falling-motifs__node is-${definition.type}${
      channel === 'bottom' ? ' is-bottom-burst' : ''
    }${node.classList.contains('is-blur') ? ' is-blur' : ''}`;
    node.style.left = `${pickSpawnX().toFixed(2)}vw`;
    node.style.setProperty('--jg-size', `${size.toFixed(2)}px`);
    node.style.setProperty('--jg-alpha', alpha.toFixed(3));
    node.style.setProperty('--jg-drift-x', `${drift.toFixed(2)}vw`);
    node.style.setProperty('--jg-duration', `${duration.toFixed(2)}s`);
    node.style.setProperty('--jg-flutter', `${(Math.random() * 800 + 400).toFixed(0)}deg`);
    node.style.setProperty(
      '--jg-entry-scale',
      (channel === 'bottom' ? 0.82 + Math.random() * 0.08 : 0.94 + Math.random() * 0.06).toFixed(3)
    );
    node.style.setProperty(
      '--jg-exit-scale',
      (channel === 'bottom' ? 0.93 + Math.random() * 0.04 : 0.98 + Math.random() * 0.06).toFixed(3)
    );

    inner.className = 'jg-falling-motifs__inner';
    inner.style.setProperty('--jg-scale', (0.92 + Math.random() * 0.18).toFixed(3));
    inner.style.setProperty('--jg-sway-x', `${sway.toFixed(2)}px`);
    inner.style.setProperty('--jg-rotate', `${rotation.toFixed(2)}deg`);
    inner.style.setProperty(
      '--jg-sway-duration',
      `${(channel === 'bottom' ? 5.4 + Math.random() * 2.1 : 6.2 + Math.random() * 2.6).toFixed(2)}s`
    );
    inner.innerHTML = definition.svg;

    node.appendChild(inner);
    return node;
  }

  function removeNode(node) {
    if (!node || !node.parentNode) {
      return;
    }

    const isBottomBurst = node.classList.contains('is-bottom-burst');
    node.parentNode.removeChild(node);

    if (isBottomBurst) {
      bottomActiveCount = Math.max(bottomActiveCount - 1, 0);
      return;
    }

    topActiveCount = Math.max(topActiveCount - 1, 0);
  }

  function attachLifecycle(node) {
    const expectedAnimation = node.classList.contains('is-bottom-burst')
      ? 'jg-motif-rise-burst'
      : 'jg-motif-fall';

    function handleAnimationEnd(event) {
      if (event.target !== node || event.animationName !== expectedAnimation) {
        return;
      }

      node.removeEventListener('animationend', handleAnimationEnd);
      removeNode(node);
    }

    node.addEventListener('animationend', handleAnimationEnd);
  }

  function spawnTopNode(shouldScheduleNext) {
    if (destroyed || document.hidden) {
      if (shouldScheduleNext !== false) {
        scheduleNextSpawn();
      }

      return;
    }

    const profile = getRuntimeProfile().top;

    if (topActiveCount < profile.maxActive) {
      const node = buildNode('top');
      topActiveCount += 1;
      attachLifecycle(node);
      overlay.appendChild(node);
    }

    if (shouldScheduleNext !== false) {
      scheduleNextSpawn();
    }
  }

  function spawnBottomNode() {
    if (destroyed || document.hidden) {
      return;
    }

    const profile = getRuntimeProfile().bottom;

    if (bottomActiveCount >= profile.maxActive) {
      return;
    }

    const node = buildNode('bottom');
    bottomActiveCount += 1;
    lastBottomSpawnAt = getNow();
    refreshBottomSustainDelay();
    attachLifecycle(node);
    overlay.appendChild(node);
  }

  function triggerBottomPulse() {
    const profile = getRuntimeProfile().bottom;
    const count = randomInt(profile.pulseCount);

    for (let index = 0; index < count; index += 1) {
      trackTimeout(function () {
        spawnBottomNode();
      }, index * 140);
    }
  }

  function handleScrollActivity() {
    updateScrollDirection();
    requestStrengthSync();

    if (scrollDirection !== 'down') {
      return;
    }

    const now = getNow();

    if (canTriggerBottomPulse(now)) {
      lastDownPulseAt = now;
      triggerBottomPulse();
      return;
    }

    if (canSustainBottomBurst(now)) {
      spawnBottomNode();
    }
  }

  function scheduleNextSpawn() {
    if (destroyed) {
      return;
    }

    if (spawnTimer) {
      window.clearTimeout(spawnTimer);
      transientTimers.delete(spawnTimer);
    }

    const wait = sample(getRuntimeProfile().top.interval);
    spawnTimer = trackTimeout(function () {
      spawnTimer = 0;
      spawnTopNode();
    }, wait);
  }

  function cleanup() {
    destroyed = true;
    overlay.dataset.initialized = 'false';

    if (spawnTimer) {
      window.clearTimeout(spawnTimer);
      transientTimers.delete(spawnTimer);
      spawnTimer = 0;
    }

    transientTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    transientTimers.clear();

    if (strengthFrame) {
      window.cancelAnimationFrame(strengthFrame);
      strengthFrame = 0;
    }

    window.removeEventListener('scroll', handleScrollActivity);
    window.removeEventListener('resize', requestStrengthSync);
    document.removeEventListener('visibilitychange', requestStrengthSync);
    window.removeEventListener('pagehide', cleanup);
    unbindMediaQueryChange(reduceMotionQuery, handleReduceMotionChange);

    while (overlay.firstChild) {
      overlay.removeChild(overlay.firstChild);
    }

    topActiveCount = 0;
    bottomActiveCount = 0;
    scrollDirection = 'idle';
  }

  function handleReduceMotionChange(event) {
    if (event.matches) {
      overlay.style.display = 'none';
      cleanup();
    }
  }

  refreshBottomSustainDelay();

  window.addEventListener('scroll', handleScrollActivity, { passive: true });
  window.addEventListener('resize', requestStrengthSync, { passive: true });
  document.addEventListener('visibilitychange', requestStrengthSync);
  window.addEventListener('pagehide', cleanup, { once: true });
  bindMediaQueryChange(reduceMotionQuery, handleReduceMotionChange);

  applyStrength();

  const initialNodes = isMobileQuery.matches ? 2 : 3;
  for (let index = 0; index < initialNodes; index += 1) {
    trackTimeout(function () {
      spawnTopNode(false);
    }, 240 * index);
  }

  scheduleNextSpawn();
})();
